import { FC, SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  size?: number
  colorType?: 'red' | 'blue'
}

export const GemIcon: FC<Props> = ({
  size = 24,
  colorType = 'red',
  ...props
}) => {
  const colors = {
    red: {
      main: '#E96565',
      stroke: '#FFB0B9',
      secondary1: '#EE8BBB',
      secondary2: '#FFC1DF',
      secondary3: '#D74E67',
      secondary4: '#AC2F48',
      dots1: '#BE3778',
      secondary5: '#FF6490',
      secondary6: '#FF9BAD',
      stroke2: '#FFD5E4',
      stroke3: '#FFADD4',
      stroke4: '#FFE7F2',
      dots2: '#B43B51',
    },
    blue: {
      main: '#6583E9',
      stroke: '#B0CFFF',
      secondary1: '#8BA2EE',
      secondary2: '#C1E4FF',
      secondary3: '#4E4FD7',
      secondary4: '#592FAC',
      dots1: '#533BB4',
      secondary5: '#6495FF',
      secondary6: '#9BB8FF',
      stroke2: '#D5E7FF',
      stroke3: '#C1E4FF',
      stroke4: '#FFE7F2',
      dots2: '#533BB4',
    },
  }

  const color = colors[colorType]

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 7.05C5 6.78478 5.10536 6.53043 5.29289 6.34289L9.34289 2.29289C9.53043 2.10536 9.78478 2 10.05 2L13.65 2C13.9152 2 14.1696 2.10536 14.3571 2.29289L18.4071 6.34289C18.5946 6.53043 18.7 6.78478 18.7 7.05L18.7 16.95C18.7 17.2152 18.5946 17.4696 18.4071 17.6571L14.3571 21.7071C14.1696 21.8946 13.9152 22 13.65 22L10.05 22C9.78478 22 9.53043 21.8946 9.34289 21.7071L5.29289 17.6571C5.10536 17.4696 5 17.2152 5 16.95L5 7.05Z"
        fill={color.main}
        stroke={color.stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M6 16.95L6 7.05005L9.375 8.17505L9.375 15.825L6 16.95Z"
        fill={color.secondary1}
      />
      <path
        d="M10.05 3L6 7.05L9.375 8.17501L11.85 5.25L13.65 3L10.05 3Z"
        fill={color.secondary2}
      />
      <path
        d="M14.3248 15.825L11.8498 18.75L10.0498 21L13.6498 21L17.6998 16.95L17.6998 7.05L13.6498 3L11.8498 5.25L14.3248 8.175L14.3248 15.825Z"
        fill={color.secondary3}
      />
      <path
        d="M17.7002 7.05005L17.7002 16.95L14.3252 15.825L14.3252 8.17505L17.7002 7.05005Z"
        fill={color.secondary4}
      />
      <ellipse
        cx="16.7986"
        cy="9.29985"
        rx="0.45"
        ry="0.45"
        fill={color.dots1}
      />
      <circle cx="16.2359" cy="11.2125" r="0.3375" fill={color.dots1} />
      <ellipse
        cx="17.0238"
        cy="10.65"
        rx="0.225"
        ry="0.225"
        fill={color.dots1}
      />
      <ellipse
        cx="15.8988"
        cy="9.975"
        rx="0.225"
        ry="0.225"
        fill={color.dots1}
      />
      <ellipse
        cx="17.0238"
        cy="7.94985"
        rx="0.225"
        ry="0.225"
        fill={color.dots1}
      />
      <ellipse
        cx="17.0238"
        cy="13.35"
        rx="0.225"
        ry="0.225"
        fill={color.dots1}
      />
      <ellipse
        cx="17.0238"
        cy="12.225"
        rx="0.225"
        ry="0.225"
        fill={color.dots1}
      />
      <path
        d="M9.375 8.175L9.375 15.825L11.85 18.75L14.325 15.8355L14.325 8.175L11.85 5.25L9.375 8.175Z"
        fill={color.secondary5}
      />
      <path
        d="M9.375 15.825L9.375 8.175L11.85 5.25L14.325 8.175L9.375 15.825Z"
        fill={color.secondary6}
      />
      <path
        d="M11.8502 5.92505L9.8252 8.40005V13.125"
        stroke={color.stroke2}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4502 7.7251V16.2751"
        stroke={color.stroke3}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.90039 6.82495L10.2754 3.44995"
        stroke={color.stroke4}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16.0113" cy="17.5125" r="0.3375" fill={color.dots2} />
      <circle cx="13.7613" cy="19.7625" r="0.3375" fill={color.dots2} />
      <circle cx="14.6617" cy="18.8624" r="0.3375" fill={color.dots2} />
      <ellipse
        cx="13.6488"
        cy="18.3"
        rx="0.225"
        ry="0.225"
        fill={color.dots2}
      />
      <ellipse cx="15.224" cy="18.3" rx="0.225" ry="0.225" fill={color.dots2} />
      <ellipse cx="14.5486" cy="17.4" rx="0.45" ry="0.45" fill={color.dots2} />
    </svg>
  )
}
